import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdFileDownload, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";
import TableEmptyState from "../ReusableComponents/TableEmptyState";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';



const SalasProcesso = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_salas, setLoadingsalas] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [salas, setsalas] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, processo_name } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [salas_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getsalas = async (page, search) => {

    let response = await Request.Get(`faculdade/get_salas/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setsalas(response.salas);

      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingsalas(false);


    }
  };






  const DeleteRedacao = async (salas_id) => {

    let response = await Request.Delete(`faculdade/desvincular_sala/${salas_id}/${processo_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getsalas(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getsalas(1, search_oficial);
  }, []);
  const user = useSelector((state) => state.AppReducer.user);

  let pesquisarTimeout = null;
  const history = useHistory();
  const backToDashboard = () => {
    props.setState({
      activeTab: -1
    });
    history.push({
      search: ''
    });
  };

  return (
    <>


            {/* <hr /> */}
            {loading_screen == false && <div className="module-card-container">

                <div className="module-breadcrumb">

                    <button
            className="breadcrumb-back"
            onClick={backToDashboard}>{t("dashboard")}


          </button>

                    <span>/</span>

                    <strong>{t("rooms")}</strong>

                </div>

                <div className="module-title-row">

                    <div>

                        <h3 style={{ fontWeight: 'bold' }}>{`
                            ${t("rooms")}
                        `}</h3>

                        <p>{`
                            ${t("legacy_gerencie_as_salas_vinculadas_ao_processo")}
                        `}</p>

                    </div>

                    <button
            className="btn-dashboard-modern"
            onClick={backToDashboard}>{`
                        ${t("legacy_dashboard")}
                    `}
          </button>

                </div>

                <div className="module-toolbar">

                    <Search
            placeholder={t("placeholder_search_room")}
            ValueChange={(value) => {

              clearTimeout(pesquisarTimeout);

              setSearchOficial(value);

              pesquisarTimeout = setTimeout(() => {

                let page = { ...pagination };

                page.current_page = 1;

                setPagination(page);

                setLoadingsalas(true);

                Getsalas(1, value);

              }, 500);

            }} />


                </div>

                <div className="table-modern-card">
                    <div className="table-modern-scroll mb-0">
                        <table id="tech-companies-1" className="table table-striped">
                            <thead>
                                <tr>

                                    <th>{t("legacy_sala")}</th>
                                    <th>{t("label_present_count")}</th>
                                    <th>{t("legacy_n_candidatos")}</th>
                                    <th>{t("legacy_n_fiscais")}</th>
                                    <th>{t("legacy_n_corretores")}</th>
                                    <th>{t("label_actions")}</th>

                                </tr>
                            </thead>
                            <tbody>
                                {loading_salas == false && salas.map((item, id) =>

                  <tr key={id}>
                                        <td>
                                            {t("legacy_sala")} {item.numero}
                                        </td>
                                        <td>
                                            <span className="status-badge-modern status-badge-neutral">
                                                {item.presentes.length}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="status-badge-modern status-badge-neutral">
                                                {item.candidatos.length}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="status-badge-modern status-badge-neutral">
                                                {item.fiscais.length}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="status-badge-modern status-badge-neutral">
                                                {item.corretores.length}
                                            </span>
                                        </td>

                                        {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                        <td>

                                            <div className="actions-group">

                                                <Link
                          to={`/salas/show/${item.id}`}>


                                                    <button
                            className="action-btn warning"
                            title={t("legacy_visualizar")}>

                                                        <BsFillEyeFill />
                                                    </button>

                                                </Link>

                                            </div>

                                        </td>

                                    </tr>
                  )}

                            </tbody>
                        </table>
                    </div>
                    {loading_salas == true &&
          <div className="row table-state-spacing" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                            {/* <div className="spinner-border text-primary" role="status"  >
                </div> */}
                            <CircularProgress />
                        </div></div>

          }
                </div>
                {loading_salas == false && salas.length == 0 && <TableEmptyState title={t("empty_no_room_found")} description={t("ui_nenhuma_sala_foi_vinculada_a_este_processo_cc8c090a")} icon="🚪" />}

                <Pagination
          className={pagination.last_page == 1 ? "hide" : ""}
          style={{ display: "flex", justifyContent: "flex-end" }}
          count={pagination.last_page}
          value={pagination.current_page}
          onChange={(_, value) => {
            setLoadingsalas(true);
            console.log(_, value);
            let page = { ...pagination };
            page.current_page = value;
            setPagination(pagination);
            Getsalas(value, search_oficial);
          }} />


                {/* {this.state.andamento == true && <AvaliacaoAndamento get_salas={this.get_salas.bind(this)} {...this.props} />} */}

            </div>}

            {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                {/* <div className="spinner-border text-primary" role="status"  >
            </div> */}
                <CircularProgress />
            </div></div>}

            <SweetAlert
        warning
        title={t("legacy_atencao")}
        onConfirm={() => {
          setShowWarning(false);
          setLoadingsalas(true);
          DeleteRedacao(salas_id);
          // this.delete_banner(this.state.banner_to_delete);
        }}
        onCancel={() => {
          setShowWarning(false);
        }}
        show={show_warning}
        confirmBtnText={t("ui_sim_desejo_desvincular_91364237")}
        cancelBtnText={t("legacy_cancelar")}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        showCancel={true}>{t("ui_ao_desvincular_este_sala_ele_nao_tera_mais_acesso__15f445ac")}


      </SweetAlert>


        </>);


};

export default SalasProcesso;
